import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={307}
    height={22}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        stroke="url(#b)"
        strokeLinecap="round"
        strokeWidth={1.5}
        d="m-44 10.733 396.799-.356"
      />
      <path
        fill="url(#c)"
        stroke="#fff"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={0.5}
        d="M165.498 11.03c-5.883-.452-10.578-5.147-11.03-11.03-.451 5.883-5.146 10.577-11.029 11.03 5.883.451 10.578 5.146 11.03 11.029.451-5.883 5.147-10.577 11.029-11.03Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={-15.56}
        x2={373.939}
        y1={32.5}
        y2={34.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.055} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.455} stopColor="#fff" />
        <stop offset={0.88} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="c"
        x1={154.469}
        x2={154.469}
        y1={0}
        y2={22.059}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.15} stopColor="#ADA23C" stopOpacity={0} />
        <stop offset={0.495} stopColor="#CEC88B" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h307v22H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgComponent
